module.exports = __webpack_public_path__ + "images/126fa4657dd3affd39c09cc784fb78f1d5566b52fdb623082586dce713a78c7e.svg";